import { ReactNode } from 'react';
import {
    ICurrenciesSelectItem,
    ICurrenciesSelectItemAPIN,
    IIncludeAssignedCompanyItem,
    IIncludeAssignedCompanyItemAPI,
    IIncludeMainItemOrNullAPI,
    INameObject,
    INameObjectN,
    IRelationshipItem,
    IStringOrNullAPI,
} from './index';

type IRateUnitValues = {
    rateData?: number;
    rateDataUnit?: string;
    rateSms?: number;
    rateSmsUnit?: string;
    rateVoiceMobile?: number;
    rateVoiceMobileUnit?: string;
    rateVoiceNet?: number;
    rateVoiceNetUnit?: string;
};
type IRateUnitIdValues = IRateUnitValues & {
    rateDataUnitId?: string;
    rateSmsUnitId?: string;
    rateVoiceMobileUnitId?: string;
    rateVoiceNetUnitId?: string;
};

type IRateCalculatedValues = {
    calculatedRateData?: number;
    calculatedRateSms?: number;
    calculatedRateVoiceMobile?: number;
    calculatedRateVoiceNet?: number;
};

type IRateDefaultUnitIdValues = {
    defaultRateData?: number;
    defaultRateDataUnit?: string;
    defaultRateDataUnitId?: string;
    defaultRateSms?: number;
    defaultRateSmsUnit?: string;
    defaultRateSmsUnitId?: string;
    defaultRateVoiceMobile?: number;
    defaultRateVoiceMobileUnit?: string;
    defaultRateVoiceMobileUnitId?: string;
    defaultRateVoiceNet?: number;
    defaultRateVoiceNetUnit?: string;
    defaultRateVoiceNetUnitId?: string;
};

export type IRateInfo = IRateCalculatedValues &
    IRateDefaultUnitIdValues & {
        id: string;
        name?: string;
        companyId?: string;
        company?: string;
        currencyId?: string;
        currency?: string;
        currencySymbol?: string;
        currencyPreviousId?: string;
        notes?: string;
        mrcActiveCard?: string;
        mrcCard?: string;
        mrcActiveImsi?: string;
        nrcCard?: string;
        nrcImsi?: string;
        outerAssignment?: boolean;
    };

export type ICheckRate = {
    rateData?: number;
    rateVoiceMobile?: number;
    rateVoiceNet?: number;
    rateXUnit?: string;
    calculatedRateX?: string;
    rateDataUnitId?: string;
    rateDataUnit?: string;
    rateSms?: number;
    rateSmsUnitId?: string;
    rateSmsUnit?: string;
};

export interface IUseRateForm extends IRateInfo {
    assignedCompanies?: IIncludeAssignedCompanyItem[];
    mrcItems?: any;
}

export type IRateCountryFormInfo = IRateCalculatedValues & {
    id: string;
    countryId?: string;
    destroy?: boolean;
    incrementData?: number;
    operatorId?: string;
    rateData?: number;
    rateDataUnit?: string;
    rateDataUnitId?: string;
    rateSms?: number;
    rateSmsUnit?: string;
    rateSmsUnitId?: string;
    rateVoiceMobile?: number;
    rateVoiceMobileUnit?: string;
    rateVoiceMobileUnitId?: string;
    rateVoiceNet?: number;
    rateVoiceNetUnit?: string;
    rateVoiceNetUnitId?: string;
};

export type IRateCountryViewTableRecord = {
    key: string;
    country: ReactNode;
    countryId: string;
    networksCount: number;
    networksCountShow: ReactNode;
    operatorId: string;
    rateData?: string | number;
    rateDataShow?: ReactNode;
    rateDataUnit?: string;
    rateDataUnitShow?: ReactNode;
    rateSms?: string | number;
    rateSmsShow?: ReactNode;
    rateSmsUnit?: string;
    rateSmsUnitShow?: ReactNode;
    rateVoiceMobile?: string | number;
    rateVoiceMobileShow?: ReactNode;
    rateVoiceMobileUnit?: string;
    rateVoiceMobileUnitShow?: ReactNode;
    calculatedRateVoiceMobile?: string;
    rateVoiceNet?: string | number;
    rateVoiceNetShow?: ReactNode;
    rateVoiceNetUnit?: string;
    rateVoiceNetUnitShow?: ReactNode;
    calculatedRateVoiceNet?: string;
};

export interface IRateCountryFormInitialValues extends IRateCountryFormInfo {
    networks?: IRateNetworkItem[];
}

export interface IRateNetworkItem extends IRateCountryFormInitialValues {
    networkId?: string;
    networkName?: string;
}
export interface IRateCountryItemApi {
    id: string;
    countryId?: string;
    operatorId?: string;
    rateData?: string;
    rateDataUnitId?: string;
    rateDataUnit?: string;
    rateSms?: string;
    rateSmsUnitId?: string;
    rateSmsUnit?: string;
    networks?: IRateNetworkItem[];
}

export interface IRateNetworkItemApi extends IRateCountryItemApi {
    networkId?: string;
    networkName?: string;
}

export interface IRateListAPI {
    data?: IRateItemAPI;
    included?: IRateIncludeItemAPI[];
}
export type IRateListRespAppliedCompanyAPIV22 = {
    id: number;
    company_id: number;
    name?: string;
    start_date?: string;
    end_date?: string | null;
    is_active?: boolean;
    is_deletable?: boolean;
};
export type IRateListRespAppliedCompanyAPIV2 = {
    id: number;
    company_id: number;
    name?: string;
    start_date?: string;
    end_date?: string;
    is_active?: boolean;
    is_deletable?: boolean;
};

export type IRateListRespEntryV2 = IRateUnitIdValues &
    IRateCalculatedValues & {
        id: string;
        countryId?: string;
        countryName?: string;
        currency?: string;
        incrementData?: number;
        networkId?: string;
        networkName?: string;
        operatorId?: string;
        operatorName?: string;
        zoneId?: string;
        zoneName?: string;
    };

export interface IRateListRespEntryAPIV2 {
    id: number;
    country?: INameObject;
    increment_data?: number;
    network?: INameObject;
    operator?: INameObject;
    rate_data?: string;
    rate_data_unit?: string;
    rate_sms?: string;
    rate_sms_unit?: string;
    rate_voice_mobile?: string;
    rate_voice_mobile_unit?: string;
    rate_voice_net?: string;
    rate_voice_net_unit?: string;
    zone?: INameObject;
}

export interface IRateListRespEntryAPIV22 {
    id: number;
    increment_data?: string | null;
    rate_data?: string | null;
    rate_data_unit?: string | null;
    rate_sms?: string | null;
    rate_sms_unit?: string | null;
    rate_voice_mobile?: string | null;
    rate_voice_mobile_unit?: string | null;
    rate_voice_net?: string | null;
    rate_voice_net_unit?: string | null;
    country?: INameObjectN | null;
    network?: INameObjectN | null;
    operator?: INameObjectN | null;
    zone?: INameObjectN | null;
}

export interface IRateListRequestAPIV2 {
    company_id?: number;
    currency_id?: number;
    default_rate_data?: number;
    default_rate_data_unit?: string;
    default_rate_sms?: number;
    default_rate_sms_unit?: string;
    default_rate_voice_mobile?: number;
    default_rate_voice_mobile_unit?: string;
    default_rate_voice_net?: number;
    default_rate_voice_net_unit?: string;
    name?: string;
    notes?: string;
}

export interface IRateListRespAPIV22 extends INameObjectN {
    notes?: string | null;
    default_rate_data?: string;
    default_rate_data_unit?: string;
    default_rate_sms?: string;
    default_rate_sms_unit?: string;
    default_rate_voice_mobile?: string;
    default_rate_voice_mobile_unit?: string;
    default_rate_voice_net?: string;
    default_rate_voice_net_unit?: string;
    company?: INameObjectN;
    currency?: ICurrenciesSelectItemAPIN;
    applied_companies?: Array<IRateListRespAppliedCompanyAPIV22>;
    sales_rate_list_entries?: Array<IRateListRespEntryAPIV22>;
}
export interface IRateListRespAPIV2 extends INameObject {
    default_rate_data?: string;
    default_rate_data_unit?: string;
    default_rate_sms?: string;
    default_rate_sms_unit?: string;
    default_rate_voice_mobile?: string;
    default_rate_voice_mobile_unit?: string;
    default_rate_voice_net?: string;
    default_rate_voice_net_unit?: string;
    notes?: string;

    applied_companies?: Array<IRateListRespAppliedCompanyAPIV2>;
    company?: INameObject;
    currency?: ICurrenciesSelectItem;
    sales_rate_list_entries?: Array<IRateListRespEntryAPIV2>;
}

export interface IRateItemAttributesAPI {
    default_rate_data?: string;
    default_rate_sms?: string;
    default_rate_voice_mobile?: string;
    default_rate_voice_net?: string;
    mrc_active_card?: number;
    mrc_active_imsi?: string;
    mrc_card?: string;
    name?: string;
    status?: string;
    notes?: string;
    nrc_card?: string;
    nrc_imsi?: string;
    outer_assignment?: boolean;
    calculated_rate_voice_mobile?: string;
    calculated_rate_voice_net?: string;
}
export interface IRateItemAPI {
    id: string;
    type: 'sales_rate_list';
    attributes?: IRateItemAttributesAPI;
    relationships?: {
        assigned_companies?: {
            data?: IRelationshipItem[];
        };
        sales_rate_list_entries?: {
            data?: IRelationshipItem[];
        };
        company?: {
            data?: IIncludeMainItemOrNullAPI;
        };
        currency?: {
            data?: IIncludeMainItemOrNullAPI;
        };
        default_rate_data_unit?: {
            data?: IIncludeMainItemOrNullAPI;
        };
        default_rate_sms_unit?: {
            data?: IIncludeMainItemOrNullAPI;
        };
        default_rate_voice_mobile_unit?: {
            data?: IIncludeMainItemOrNullAPI;
        };
        default_rate_voice_net_unit?: {
            data?: IIncludeMainItemOrNullAPI;
        };
    };
}

export type IRateIncludeItemAPI = IIncludeAssignedCompanyItemAPI | IIncludeRateRateListAPI;

export type IIncludeRateAttributesAPI = {
    calculated_rate_data?: number;
    calculated_rate_sms?: number;
    increment_data?: number;
    rate_data: IStringOrNullAPI;
    rate_sms: IStringOrNullAPI;
    rate_voice_mobile: IStringOrNullAPI;
    rate_voice_mobile_unit?: number;
    calculated_rate_voice_mobile?: number;
    rate_voice_net: IStringOrNullAPI;
    rate_voice_net_unit?: number;
    calculated_rate_voice_net?: number;
};

export interface IIncludeRateRateListAPI extends IRelationshipItem {
    attributes: IIncludeRateAttributesAPI;
    relationships?: {
        country?: {
            data?: {
                id: string;
                type: 'country';
            };
        };
        network?: {
            data?: {
                id: string;
                type: 'operator';
            };
        };
        operator?: {
            data?: {
                id: string;
                type: 'operator';
            };
        };
        rate_data_unit?: {
            data?: {
                id: string;
                type: 'rate_unit';
            };
        };
        rate_sms_unit?: {
            data?: {
                id: string;
                type: 'rate_unit';
            };
        };
        rate_voice_mobile_unit?: {
            data?: {
                id: string;
                type: 'rate_unit';
            };
        };
        rate_voice_net_unit?: {
            data?: {
                id: string;
                type: 'rate_unit';
            };
        };
    };
}

export type IMemCountryFormProps = {
    apiMessagesLastUpdated: number;
    expandedCountryRowKey?: string;
    initialValues: IRateCountryFormInitialValues;
    name: string;
    setExpandedCountryRowKey?: (id: string) => void;
};

export interface IRateCountryLoadingStats {
    expectedToLoad: number;
    alreadyLoaded: number;
}

export enum RareFormTab {
    INFO = 'info',
    COMPANIES = 'companies',
    RATES = 'rates',
}

export type IRespSalesRateListAssignedCompany = {
    id: number;
    start_date: string;
    company: {
        id: number;
        name: string;
    };
    is_active?: boolean;
    is_deletable?: boolean;
    sales_rate_list: {
        id: number;
        name: string;
    };
};
